import { render, staticRenderFns } from "./ChatLobby.vue?vue&type=template&id=389ed965&"
import script from "./ChatLobby.vue?vue&type=script&lang=js&"
export * from "./ChatLobby.vue?vue&type=script&lang=js&"
import style0 from "./ChatLobby.vue?vue&type=style&index=0&id=389ed965&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports